import React from "react";
import { StyledLogo } from "./Logo.styles";
import { TEAM_NAME } from "../../../utils/info";

const Logo = ({ width, height, style }) => {
    return (
        <StyledLogo
            width={width}
            height={height}
            style={style}
            src={"/logo.png"}
            alt={TEAM_NAME}
        />
    );
};

export default Logo;
